<template>
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="mb-0">
        <i class="bi bi-circle-square me-2"></i>Topic Circles
      </h5>
    </div>
    <div class="card-body p-0">
      <div class="topic-list">
        <!-- All Topics Option -->
        <div 
          class="topic-item"
          :class="{ active: selectedTopic === null }"
          @click="selectTopic(null)"
        >
          <div class="topic-icon">
            <i class="bi bi-grid"></i>
          </div>
          <div class="topic-info">
            <div class="topic-name">All Topics</div>
            <small class="topic-count">Show all posts</small>
          </div>
        </div>
        
        <!-- Individual Topics -->
        <div 
          v-for="topic in topics" 
          :key="topic.id"
          class="topic-item"
          :class="{ active: selectedTopic === topic.id }"
          @click="selectTopic(topic.id)"
        >
          <div class="topic-icon">
            <i :class="topic.icon"></i>
          </div>
          <div class="topic-info">
            <div class="topic-name">{{ topic.name }}</div>
            <small class="topic-count">{{ topicPostCounts[topic.id] || 0 }} posts</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopicCircles',
  props: {
    topics: {
      type: Array,
      required: true
    },
    selectedTopic: {
      type: String,
      default: null
    },
    topicPostCounts: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['select-topic'],
  methods: {
    selectTopic(topicId) {
      this.$emit('select-topic', topicId)
    }
  }
}
</script>

<style scoped>
/* Topic Circles */
.topic-list {
  padding: 0;
}

.topic-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: all 0.3s ease;
}

.topic-item:hover {
  background-color: #f8f9fa;
}

.topic-item.active {
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
}

.topic-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 1rem;
}

.topic-info {
  flex: 1;
}

.topic-name {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.topic-count {
  color: #6c757d;
}
</style>